module.exports = __webpack_public_path__ + "img/永辉优选.acbd130a.jpg";